// How a notification READS — the section's name and the age of the row.
//
// ⚠️ ONE MODULE, TWO HOSTS: the bell dropdown (`components/NotificationPanel`)
// and the full page (`pages/Notifications`). These were the dropdown's own
// private constants; copying them for the page would mean a section added to
// `Notification.section` getting a proper label in one place and printing as a
// raw lower-case key in the other, which is exactly the drift this codebase
// keeps paying for elsewhere.

export const SECTION_LABEL = {
  tasks: 'Tasks',
  'client-requests': 'Client requests',
  chat: 'Chat',
  notices: 'Notices',
  approvals: 'Approvals',
  leave: 'Leave',
  finance: 'Finance',
  attendance: 'Attendance',
  // ⚠️ The one section with no nav entry behind it, so it lights no sidebar dot
  // and its rows are not a link to anywhere — an announcement IS the thing, not
  // a pointer to it. It still needs a label here or the fallback below prints
  // the raw key in lower case.
  announcements: 'Announcement',
};

// The order the filter offers them in: what arrives most often first, rather
// than alphabetically — a list of nine is scanned, and the two or three a
// person actually filters by should not be in the middle of it.
export const SECTION_ORDER = [
  'tasks', 'approvals', 'client-requests', 'chat', 'notices',
  'finance', 'attendance', 'leave', 'announcements',
];

export const sectionLabel = (key) => SECTION_LABEL[key] || key;

// "3m", "4h", "2d" — deliberately not a library. These are all recent by
// construction (the TTL deletes at 180 days) and the exact minute never matters
// on a notification, only the order of magnitude.
export function ago(iso) {
  const secs = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

/** The full stamp, for the page — the hover title behind the relative age. */
export const exactly = (iso) =>
  new Date(iso).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
